/* eslint-disable max-len, quote-props */
import { INTL_IDS } from './messages';

export const CANCEL_OTP = 'app/Payments/OneTimePayment/CANCEL_OTP';
export const CANCEL_OTP_FAILURE = 'app/Payments/OneTimePayment/CANCEL_OTP_FAILURE';
export const CANCEL_OTP_SUCCESS = 'app/Payments/OneTimePayment/CANCEL_OTP_SUCCESS';

export const CHANGE_INPUT = 'app/Payments/OneTimePayment/CHANGE_INPUT';
export const CHANGE_SCHEDULED_DATE = 'app/Payments/OneTimePayment/CHANGE_SCHEDULED_DATE';
export const CHANGE_SCHEDULED_DATE_ON_DECK = 'app/Payments/OneTimePayment/CHANGE_SCHEDULED_DATE_ON_DECK';

export const CHANGE_STEP = 'app/Payments/OneTimePayment/CHANGE_STEP';

export const CREATE_OTP = 'app/Payments/OneTimePayment/CREATE_OTP';
export const CREATE_OTP_FAILURE = 'app/Payments/OneTimePayment/CREATE_OTP_FAILURE';
export const CREATE_OTP_SUCCESS = 'app/Payments/OneTimePayment/CREATE_OTP_SUCCESS';
export const CREATE_OTP_VALIDATION_FAILURE = 'app/Payments/OneTimePayment/CREATE_OTP_VALIDATION_FAILURE';

export const FETCH_PAYMENT_HOME = 'app/Payments/OneTimePayment/FETCH_PAYMENT_HOME';
export const FETCH_PAYMENT_HOME_FAILURE = 'app/Payments/OneTimePayment/FETCH_PAYMENT_HOME_FAILURE';
export const FETCH_PAYMENT_HOME_SUCCESS = 'app/Payments/OneTimePayment/FETCH_PAYMENT_HOME_SUCCESS';

export const NACHA_SAVE_TOKEN = 'app/Payments/OneTimePayment/NACHA_SAVE_TOKEN';

export const RESET_BANNER_ERROR = 'app/Payments/OneTimePayment/RESET_BANNER_ERROR';

export const RESET_CANCEL_CONFIRMATION = 'app/Payments/OneTimePayment/RESET_CANCEL_CONFIRMATION';
export const RESET_CONFIRMATION = 'app/Payments/OneTimePayment/RESET_CONFIRMATION';
export const RESET_ONE_TIME_PAYMENT_STATE = 'app/Payments/OneTimePayment/RESET_ONE_TIME_PAYMENT_STATE';
export const RESET_STEP = 'app/Payments/OneTimePayment/RESET_STEP';

export const SET_BANNER_ERROR = 'app/Payments/OneTimePayment/SET_BANNER_ERROR';
export const SET_IS_AMOUNT_DRAWER_OPEN = 'app/Payments/OneTimePayment/SET_IS_AMOUNT_DRAWER_OPEN';
export const SET_IS_MODAL_OPEN = 'app/Payments/OneTimePayment/SET_IS_MODAL_OPEN';

export const UPDATE_AMOUNT = 'app/Payments/OneTimePayment/UPDATE_AMOUNT';

export const UPDATE_PAYMENT_HOME_INIT = 'app/Payments/OneTimePayment/UPDATE_PAYMENT_HOME_INIT';

export const ERROR_LOADING_MESSAGE = 'Error loading, please refresh the page';
export const NACHA_ERROR_MESSAGE = 'There is an issue with the account information provided. If you think this is in error, please call: {{customerServicePhoneNumber}}.';

export const MAX_TOTAL_AMOUNT_ERROR = 'Total Payment amount is greater than allowed amount of {{maxTotalPayment}}.';
export const ZERO_AMOUNT_ERROR = 'Total payment amount has to be greater than zero.';

export const CANCEL_OTP_DICTIONARY = {
  error: {
    buttonText: 'Return to Payments',
    header: 'Payment Cancellation Unsuccessful',
    text: 'Please try again or call customer service.',
  },
  successDesktop: {
    buttonText: 'Return to Payments',
    header: 'Success! Your payment request has been canceled',
    text: 'Your payment request of <b>{{amount}}</b> for <b>{{date}}</b> will not be processed.',
  },
  successMobile: {
    buttonText: 'Make Another Payment',
    header: 'Your One-Time Payment has been canceled',
    text: 'Your payment request of <b>{{amount}}</b> for <b>{{date}}</b> will not be processed.',
  },
};

export const CANCEL_OTP_MODAL_DICTIONARY = {
  text: 'We will immediately cancel your pending request of <b>{{amount}}</b> for <b>{{date}}</b>.',
  title: 'Are you sure you want to cancel your payment request?',
};

export const CANCEL_SCHEDULED_PAYMENT = 'Cancel_Scheduled_Payment';

export const CONFIRMATION_DICTIONARY_OTP = {
  animationName: 'flyingMoney',
  errorHeader: 'Payment Error',
  errorLinkLabel: 'Back to Payments',
  errorSubHeader: 'There was a problem with your request',
  errorText: 'Please try again or call customer service.',
  labelArray: [
    { key: 'confirmationNumber', label: 'Confirmation Details' },
    { key: 'scheduledTotalPayment', label: 'Payment Amount' },
    { key: 'numberOfPayments', label: 'Number of Payments' },
    { key: 'scheduledDate', label: 'Scheduled Date' },
  ],
  modalToOpen: 'cancel',
  successHeader: 'One-Time Payment Confirmation',
  successHeaderMobile: 'Payment Confirmation',
  successLinkLabel: 'Cancel One-Time Payment Request',
  successSubHeader: 'Good News! We received your payment request',
  successText: 'Payments may take up to 2 business days to post. However, the transaction will be effective for the date submitted based on central standard time.',
};

export const DEFAULT_CREATE_OTP_ERRORS = {
  accountNumber: '',
  accountNumberConfirm: '',
  additionalEscrow: '',
  additionalPrincipal: '',
  bankName: '',
  bannerError: false,
  lateCharge: '',
  nameOnAccount: '',
  nsfFees: '',
  numberOfPayments: '',
  otherFees: '',
  routingNumber: '',
  scheduledDate: '',
  sourcesBannerError: false,
};

export const OTP_SPLASH_DICTIONARY = {
  buttonLabel: 'Make a One-Time Payment',
  headerText: 'Make a one-time payment',
};

// Payments reasons and error codes
export const REASON_CODE_DICTIONARY = {
  // One-Time Scheduled Payment Reason Codes
  '15004.2000': {
    key: 'routingNumber',
    message: 'Routing Number is Required',
    screen: 'PaymentSourceForm',
  },
  '15004.2001': {
    key: 'routingNumber',
    message: 'Routing Number is invalid',
    screen: 'PaymentSourceForm',
  },
  '15004.2002': {
    key: 'accountNumber',
    message: 'Account Number is Required',
    screen: 'PaymentSourceForm',
  },
  '15004.2003': {
    key: 'accountNumber',
    message: 'Account Number is invalid',
    screen: 'PaymentSourceForm',
  },
  '15004.2004': {
    key: 'nameOnAccount',
    message: 'Name on Account is Required',
    screen: 'PaymentSourceForm',
  },
  '15004.2005': {
    key: 'nameOnAccount',
    message: 'Invalid name',
    screen: 'PaymentSourceForm',
  },
  '15004.2010': {
    key: 'bannerError',
    message: 'You are not allowed to make an Additional payment for the selected loan.',
    screen: 'EditPayment',
  },
  '15004.2012': {
    key: 'bannerError',
    message: 'You are not allowed to make a Monthly payment for the selected loan.',
    screen: 'EditPayment',
  },
  '15004.2014': {
    key: 'bannerError',
    message: 'Scheduled Draft date is invalid.',
    screen: 'SchedulePayment',
  },
  '15004.2015': {
    key: 'bannerError',
    message: 'Number of payments is invalid',
    screen: 'EditPayment',
  },
  '15004.2016': {
    key: 'additionalPrincipal',
    message: 'Additional Principal not allowed',
    screen: 'EditPayment',
  },
  '15004.2017': {
    key: 'additionalEscrow',
    message: 'Additional Escrow not allowed',
    screen: 'EditPayment',
  },
  '15004.2018': {
    key: 'lateCharge',
    message: 'Late charge is invalid',
    screen: 'EditPayment',
  },
  '15004.2019': {
    key: 'bannerError',
    message: 'All input values must be greater than 0.',
    screen: 'EditPayment',
  },
  '15004.2020': {
    key: 'bannerError',
    message: 'Total payment amount has to be greater than zero.',
    screen: 'EditPayment',
  },
  '15004.2021': {
    key: 'bannerError',
    message: 'Total Payment amount is greater than allowed amount of {{maxTotalPayment}}.',
    screen: 'EditPayment',
  },
  '15004.2022': {
    key: 'nsfFees',
    message: 'NSF Fee is invalid',
    screen: 'EditPayment',
  },
  '15004.2024': {
    key: 'sourcesBannerError',
    message: 'Unable to use existing account information, please provide your account information again.',
    screen: 'PaymentSourceForm',
  },
  '15004.2026': {
    key: 'sourcesBannerError',
    message: NACHA_ERROR_MESSAGE,
    screen: 'PaymentSourceForm',
  },
  '15004.2027': {
    key: 'sourcesBannerError',
    message: NACHA_ERROR_MESSAGE,
    screen: 'PaymentSourceForm',
  },
};

export const FULL_ERROR_REASON_CODES = ['15004.2023'];

export const REVIEW_DICTIONARY_OTP = {
  desktop: { headerTitle: 'Review One-Time Payment Details' },
  mobile: { headerTitle: 'Review One-Time Payment' },
  shared: {
    heading: 'Almost done. Review your details',
    latePaymentCheckboxLabel: 'I understand that my payment may incur a late fee',
    paragraphText: 'Payments may take up to 2 business days to post. However, the transaction will be effective for the date submitted based on central standard time.',
  },
};

export const TOOLTIP_PROPS = {
  additionalPayments: {
    content: INTL_IDS.TOOLTIP_ADDITIONALPAYMENTS_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_ADDITIONALPAYMENTS_TITLE,
  },
  numberOfMonthlyPayments: {
    content: INTL_IDS.TOOLTIP_NUMBEROFMONTHLYPAYMENTS_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_NUMBEROFMONTHLYPAYMENTS_TITLE,
  },
  regularMonthlyPayment: {
    content: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_CONTENT,
    linkText: INTL_IDS.TOOLTIP_LINKTEXT,
    title: INTL_IDS.TOOLTIP_REGULARMONTHLYPAYMENT_TITLE,
  },
};

export const INFO_COPY_DICT = {
  review: [{
    isReview: true,
    text: INTL_IDS.INFOCOPY_REVIEW_IFPAYMENTISTIMELYSUBMITTED,
    variant: 'pending',
  }],
};

export const LATE_PAYMENT_WARNING_MODAL_PROPS = {
  header: 'Please choose an earlier date to avoid additional charges',
  proceedLabel: 'Proceed with Scheduling Payment',
  text: 'A payment made before the grace period expiration specified in your loan documents will not incur a late fee. Scheduling payments beyond the grace period specified in your loan documents may incur a late fee.',
  updateLabel: 'Update Payment Date',
};

export const PAYMENT_FLOW_TYPE_OTP = 'otp';
